import React from "react";
import styles from "./template-widget-error.module.scss";
import { AnchorButton } from "@whatslly/ui-components/v2/Button";
import { APEX_LINK } from "@whatslly/commons/constants";
import { useTranslation } from "react-i18next";
import { Svg } from "@whatslly/ui-components/v2/BaseElements/Svg";
import { TemplatesFilter } from "@whatslly/instant-messaging/react-app/templates-widget/components/TemplatesFilter/TemplatesFilter";

export const TemplateWidgetError: React.FC<{
  errorType: "MISSING_APEX" | "UPGRADE" | "NO_TEMPLATES";
  templateEditorUrlHref?: string;
  allowAdd: boolean;
  close: () => void;
}> = React.memo(({ errorType, templateEditorUrlHref, allowAdd, close }) => {
  const { t } = useTranslation();

  const message = (() => {
    if (errorType === "MISSING_APEX") {
      return <h2>{t("error_please_install_apex")}</h2>;
    }
    if (errorType === "UPGRADE") {
      return (
        <>
          <Svg iconName="lock" width={24} height={24} />
          <h2>{t("message_only_for_upgraded_users")}</h2>
        </>
      );
    }
    return (
      <>
        <h2>{t("templates.title")}</h2>
        <p data-testid="no-templates">
          {t("templates.seems_like_no_templates")}
          {allowAdd ? ` ${t("templates.time_to_create_a_new_one")}` : ""}
        </p>
      </>
    );
  })();

  const linkMessage = (() => {
    if (errorType === "MISSING_APEX") {
      return t("button_click_here_to_install");
    }
    if (errorType === "NO_TEMPLATES") {
      return (
        <>
          <Svg className={styles.plusIcon} iconName="plus" width={13} height={13} />
          {t("templates.create_new")}
        </>
      );
    }
  })();

  const linkHref = (() => {
    if (errorType === "MISSING_APEX") {
      return APEX_LINK;
    }
    if (errorType === "NO_TEMPLATES" && allowAdd) {
      return templateEditorUrlHref;
    }
  })();

  return (
    <div className={styles.errorV2}>
      <Svg iconName="close" className={styles.close} onClick={close} width={14} height={14} />
      <TemplatesFilter className={styles.templatesFilter} collapsibleMenuClassName={styles.templatesFilterMenu} />
      {message}
      {linkMessage && linkHref && (
        <AnchorButton secondary borderRadius="default" href={linkHref} target="sfdc">
          {linkMessage}
        </AnchorButton>
      )}
    </div>
  );
});
